import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LandingFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-foreground/10 py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link to="/" className="logo">
            Vesper
          </Link>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-sm">
            <Link to="/privacy" className="hover:text-primary transition-colors">
              {t("footer.privacy")}
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              {t("footer.terms")}
            </Link>
            <Link to="/contact" className="hover:text-primary transition-colors">
              {t("footer.contact")}
            </Link>
            <Link to="/install" className="hover:text-primary transition-colors">
              {t("footer.install")}
            </Link>
          </nav>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
